import Icon from '../components/Icon.vue'

Icon.register({
  sort: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M41 288h238c21.4 0 32.1 25.9 17 41l-119 119c-9.4 9.4-24.6 9.4-33.9 0l-119.1-119c-15.1-15.1-4.4-41 17-41zM296 183c15.1 15.1 4.4 41-17 41h-238c-21.4 0-32.1-25.9-17-41l119.1-119c9.3-9.4 24.5-9.4 33.9 0z'
      }
    ]
  }
})
